/** @jsx jsx */
import { css as emotionCss, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

const styles = {
  svg: emotionCss`
    display: block;
  `,
};

type Props = {
  width?: number;
  height?: number;
  css?: SerializedStyles;
};

const CoursesHeroImageSvg = ({ width = 566, height = 465, css }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 555 465"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={[styles.svg, css]}
    >
      <g clipPath="url(#clip0_71_9950)">
        <path
          d="M219.118 125.669L163.127 0.0642639C49.9173 50.5301 -15.5504 170.485 3.25344 292.999C22.0573 415.513 120.486 510.313 243.619 524.504C366.753 538.695 484.165 468.77 530.345 353.745L402.727 302.51C379.637 360.022 320.931 394.985 259.364 387.889C197.797 380.794 148.583 333.394 139.181 272.137C129.779 210.879 162.513 150.902 219.118 125.669Z"
          fill="var(--cds-color-emphasis-primary-background-weak)"
        />
        <g opacity="0.4">
          <path
            d="M272.295 359.201C308.071 361.069 342.145 343.79 361.776 313.824L446.005 369.005C406.742 428.937 338.593 463.496 267.043 459.759L272.295 359.201ZM268.094 458.809C338.591 462.14 405.649 428.134 444.617 369.292L362.057 315.205C342.333 344.678 308.674 361.747 273.242 360.244L268.094 458.809Z"
            fill="var(--cds-color-emphasis-neutral-background-default)"
          />
        </g>
        <g opacity="0.4">
          <path
            d="M183.678 293.864C196.284 327.396 225.757 351.707 261.075 357.704L244.218 456.977C173.581 444.983 114.635 396.363 89.4228 329.297L183.678 293.864ZM90.7143 329.88C115.878 395.818 173.88 443.66 243.4 455.82L259.922 358.514C225.019 352.234 195.904 328.22 183.1 295.148L90.7143 329.88Z"
            fill="var(--cds-color-emphasis-neutral-background-default)"
          />
        </g>
        <g opacity="0.1">
          <path
            d="M198.266 184.654L121.552 119.428C75.1414 174.012 61.2259 249.145 85.0093 316.731L179.995 283.305C168.103 249.512 175.061 211.946 198.266 184.654Z"
            fill="var(--cds-color-emphasis-neutral-background-default)"
          />
        </g>
        <g opacity="0.15">
          <path
            d="M302.816 147.658L325.791 49.6192C256.033 33.2716 182.842 55.2174 133.587 107.25L206.714 176.474C231.342 150.457 267.937 139.484 302.816 147.658Z"
            fill="var(--cds-color-emphasis-neutral-background-default)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_71_9950">
          <rect width="555" height="465" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CoursesHeroImageSvg;
